import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const resetWindowScroll = () => {
  const html = document.documentElement;
  const body = document.body;
  html.scrollTop = 0;
  body.scrollTop = 0;
  if (typeof window.scrollTo === "function") {
    window.scrollTo(0, 0);
  }
  if (window.visualViewport) {
    window.scrollTo(0, 0);
  }
};

const resetOverflowScrollers = () => {
  const root = document.getElementById("root");
  if (root) root.scrollTop = 0;

  document.querySelectorAll(
    ".page-full, .page-wrapper, .landing-full, .landing-wrapper, .about-page-full, .about-page-wrapper, .privacy-page-full, .search-page-full, .search-results-page-full"
  ).forEach((node) => {
    node.scrollTop = 0;
    node.scrollLeft = 0;
  });
};

const scrollToTop = () => {
  resetWindowScroll();
  resetOverflowScrollers();
};

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    scrollToTop();
    const frameId = window.requestAnimationFrame(scrollToTop);
    const timeoutId = window.setTimeout(scrollToTop, 100);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.clearTimeout(timeoutId);
    };
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
